import React, { useEffect, useState } from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import FilterGroupChips from './FilterGroupChips';
import { translate } from '../../Services/translation';
import { useDispatch, useSelector } from 'react-redux';
import { clearAllFilters } from '../../Actions/ProductFiltering.action';
import { useMemo } from 'react';
import Icon from '../Icon';
import Input from '../Inputs/Input';
import { debounce, filter } from 'lodash-es';
import { queryProductFiltering } from '../../Actions/ProductFiltering.action';

const ActiveFilterChips = () => {
  const { current } = useTypedSelector((state) => state.userInfo);
  const { noHit } = useTypedSelector((state) => state.productListing);
  const dispatch = useDispatch();
  const filters = useTypedSelector(
    (state) => state.productFiltering?.filters
  );

  const hasAnyOptionSelected = useMemo(() => {
    if (filters && filters.length > 0) {
      return filters.findIndex((f) => f.selectedOptions.length > 0) != -1;
    }
    return false;
  }, [filters]);

  const debouncedQuery = debounce((text) => SetSearchParam(text), 300);

  const [searchParam, SetSearchParam] = useState<string>();

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);

    if (searchParam != undefined) {
      query.delete('q');
      query.set('q', searchParam);
      const queryStr = query.toString();
      const url =
        window.location.href.replace(window.location.search, '') +
        (queryStr.length > 0 ? `?${queryStr}` : '');

      window.history.replaceState('setqueryparam', '', url);
      dispatch(queryProductFiltering(null, false, true));
    } else if (query.has('q') && searchParam == undefined) {
      query.delete('q');
      const queryStr = query.toString();
      const url =
        window.location.href.replace(window.location.search, '') +
        (queryStr.length > 0 ? `?${queryStr}` : '');

      window.history.replaceState('setqueryparam', '', url);
      dispatch(queryProductFiltering());
    }
  }, [searchParam, dispatch]);

  return current?.isBusinessCustomer &&
    (hasAnyOptionSelected || !!searchParam) ? (
    <div className="mb-4 flex flex-row justify-between lg:items-center md-down:-mr-4 md-down:w-[calc(100vw_-_2rem)] md-down:flex-col">
      <div className="flex gap-2 overflow-x-auto whitespace-nowrap md-down:-ml-4 md-down:-mr-4 md-down:border-y md-down:border-gray-100 md-down:px-4 md-down:py-3">
        <a
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-r-gray-100 bg-white px-3 py-1.5 text-sm"
          onClick={() => {
            debouncedQuery(undefined);
            dispatch(clearAllFilters());
          }}
        >
          {translate('product-filtering.clear-all-filters')}
          <Icon
            name="close"
            cursor="pointer"
            className="h-4 w-4 text-gray-700"
          />
        </a>
        {filters?.map((g) => (
          <FilterGroupChips key={g.id + 'chips'} filterGroup={g} />
        ))}
      </div>
      <div className="mt-3 md:w-[300px] lg:mt-0  md-down:w-[calc(100vw_-_2rem)]">
        <Input
          className="bg-gray-100 text-lg text-gray-700 placeholder-gray-700"
          icon="search"
          placeholder={translate('filter.categories-search')}
          onChange={(event) => {
            const text = encodeURIComponent(event.target.value);
            debouncedQuery(text);
          }}
          inputState={noHit ? 'error' : 'default'}
          helperText={
            noHit ? translate('general.search.no-hit') : undefined
          }
        />
      </div>
    </div>
  ) : hasAnyOptionSelected ? (
    <div className="mb-4 flex gap-2 overflow-x-auto whitespace-nowrap md-down:-mr-4 md-down:w-[calc(100vw_-_2rem)]">
      <a
        className="flex items-center gap-2 whitespace-nowrap rounded-md border border-r-gray-100 bg-white px-3 py-1.5 text-sm"
        onClick={() => dispatch(clearAllFilters())}
      >
        {translate('product-filtering.clear-all-filters')}
        <Icon
          name="close"
          cursor="pointer"
          className="h-4 w-4 text-gray-700"
        />
      </a>
      {filters?.map((g) => (
        <FilterGroupChips key={g.id + 'chips'} filterGroup={g} />
      ))}
    </div>
  ) : null;
};

export default ActiveFilterChips;
